import React, { useEffect } from 'react';

import { getGraphWidgetTableColumns } from 'common/Widgets/DataTable/utils';
import { useWidgetContext } from 'common/Widgets/Widget/WidgetContext';
import DynamicColumnTable from 'components/DynamicColumnsTable/DynamicColumnsTable';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { localizeAreaLabel } from 'utils/helpers/units';

import { getGroupedTableDataCsv } from './utils';

interface Props {
  data: any;
}

const DataTableGrouped = ({ data }: Props) => {
  const { community, competitors, competitorId } = useCommunityViewContext();
  const { filters, type, setCSVData } = useWidgetContext();

  const filterCompetitorIds = filters?.competitors ?? [];
  const competitorsList = competitorId
    ? [(competitors ?? []).find((competitor) => competitor?.id === competitorId)].filter(Boolean) // if on Competitor screen, we show only that competitors in table
    : [
        ...(competitors ?? []).filter(
          (competitor: any) => !filterCompetitorIds.length || filterCompetitorIds.includes(competitor?.id)
        ),
      ];

  const safeData = Array.isArray(data) ? data : [];
  const groupByValues = new Set(safeData.map((item: any) => item.group_by));
  const preparedData = Array.from(groupByValues).map((rowName: any) => ({
    rowName: typeof rowName === 'string' ? localizeAreaLabel(rowName, community) : rowName,
    rowValues: [community, ...competitorsList].filter(Boolean).map((communityItem: any) => {
      const matchingDataItem = safeData.find(
        (item: any) => item.group_by === rowName && item.community_id === communityItem.id
      );
      return {
        value: matchingDataItem?.value ?? null,
        difference: matchingDataItem?.difference ?? null,
      };
    }),
  }));

  useEffect(() => {
    setCSVData(getGroupedTableDataCsv(community, competitorsList, preparedData, type, filters?.valueDisplay));
  }, [data, filters?.valueDisplay]);

  return (
    <DynamicColumnTable
      dataSource={preparedData}
      community={community}
      competitors={competitorsList}
      className="graph-widget-table"
      paddingTop="0px"
      generateTableColumns={getGraphWidgetTableColumns}
    />
  );
};

export default DataTableGrouped;
